import React, {Component, ReactElement, ReactNode} from 'react'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    CASH_PAYMENT_STATUS,
    CHARGE_UNIT,
    FACILITY_RESERVATION_CLASSIFICATION,
    MESSAGE_TYPE,
    PAYMENT_TYPE,
    VALID_OR_NOT,
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatFacilityReserveRepo from './repository/NatFacilityReserveRepo'
import {NatGetFacilityReserve, Options} from './repository/NatGetFacilityReserve'
import FacilityForReservation, {OptionSetting} from '../../../components/facilities/FacilityForReservation'
import {ReservationOption, ReserveFacilityModel} from '../../../components/reservations/ReserveFacilityModel'
import HolidaysRepository from '../../../components/HolidaysRepository'
import {
    getAcceptedWarningList,
    getHourLabel,
    getMinutsLabel,
    getYearAfterNextDateFac,
    getYearDateFac,
} from '../../common/util/Natutil'
import {
    FacilityOption,
} from '../../../components/reservations/ResidentReserveFacilityFormComponents/RRFFReserveOptionInput'
import {formatNumberWithCommas} from '../../../formatters/formatNumberWithCommas'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import NatAdminFacilityReserveOptionComponent from './admin/NatAdminFacilityReserveOpsionComponent'
import NatAdminFacilityReserveInfoComponent from './admin/NatAdminFacilityReserveInfoComponent'
import {NatAdminFacilityReserveInfo, NatFacilityOptionDetailInfo} from './admin/NatAdminFacilityReserve'
import NatAdminFacilityReserveChargeViewComponent from './admin/NatAdminFacilityReserveChargeViewComponent'
import NatAdminFacilityReserveUserInfoViewComponent from './admin/NatAdminFacilityReserveUserInfoViewComponent'
import NatAdminFacilityReserveReserveUserInfoViewComponent
    from './admin/NatAdminFacilityReserveReserveUserInfoViewComponent'
import {
    FacilityReserveCharge,
    FacilityReserveOption,
    NatPutFacilityReserveOvernight,
    NatPutFacilityReserveOvernightRequest,
    SharedUseRoomNumber,
} from './repository/NatPutFacilityReserveOvernight'
import {
    NatPutFacilityReserveDuration,
    NatPutFacilityReserveDurationRequest,
} from './repository/NatPutFacilityReserveDuration'
import {Informations} from '../common/repository/NatBaseResponseInterface'
import {ReservationsRepositoryForAdmin} from '../../../components/reservations/admin/ReservationsRepositoryForAdmin'
import {ExcudeResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import {formatForDateInput} from '../../../formatters/formatDate'
import moment from 'moment'
import NatAdminCommonAcceptedWarningComponent from '../common/admin/NatAdminCommonAcceptedWarningComponent'
import {Box} from '@mui/material'
import {AcceptedWarning} from '../common/admin/NatAcceptedWarning'
import {Location} from 'react-router-dom'

const SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface LocationState {
    version: number
}

interface Props {
    reservationsRepositoryForAdmin: ReservationsRepositoryForAdmin
    facilityReserveRepo: NatFacilityReserveRepo
    RidgeRepo: NatRidgeRepo
    RoomToResidentRepo: NatRoomToResidentRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    holidaysRepo: HolidaysRepository
    facilityId: string
    facilityReserveId: string
    reservationModel: ReserveFacilityModel
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState>,
}

interface States {
    facilityData: Nullable<FacilityForReservation>
    facilityReserveEditInfo: Nullable<NatAdminFacilityReserveInfo>
    facilityOptions: Nullable<FacilityOption[]>
    facilityOptionsDetailInfo: Nullable<NatFacilityOptionDetailInfo[]>
    reservationOptions: Nullable<ReservationOption[]>
    excudeResidentUserInfo: Nullable<ExcudeResidentUserInfo>
    userRidgeName: string
    userRoomNumber: string
    userFamilyName: string
    userFirstName: string
    adminFamilyName: string
    adminFirstName: string
    userRoleName: string
    reserveFamilyName: string
    reserveFirstName: string
    reserveRoleName: string
    selectedCondominiumCd: string
    registerButtonDisabled: boolean
    isLoadCompleted: boolean
    totalCharge: Nullable<number>
    facilityReserveCharge: FacilityReserveCharge[]
    cheked: boolean
    information: Informations[]
    acceptedWarning: AcceptedWarning[]
    holidays: Nullable<string[]>
    version: number
    currentDateTime: Nullable<moment.Moment>
}

class NatAdminFacilityReserveEditPage extends Component<Props & AdminPagePropsSet, States> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const selectedCondominiumCd: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(SELECTED_CONDOMINIUM_CD)

        this.state = {
            facilityData: null,
            facilityReserveEditInfo: null,
            facilityOptions: null,
            facilityOptionsDetailInfo: null,
            reservationOptions: null,
            excudeResidentUserInfo: null,
            userRidgeName: '',
            userRoomNumber: '',
            userFamilyName: '',
            userFirstName: '',
            adminFamilyName: '',
            adminFirstName: '',
            userRoleName: '',
            reserveFamilyName: '',
            reserveFirstName: '',
            reserveRoleName: '',
            selectedCondominiumCd: String(selectedCondominiumCd),
            registerButtonDisabled: false,
            isLoadCompleted: false,
            totalCharge: null,
            facilityReserveCharge: [],
            cheked: false,
            information: [],
            acceptedWarning: [],
            holidays: null,
            version: this.props.location.state.version,
            currentDateTime: null,
        }

        this.onChangeFacilityReserveInfo = this.onChangeFacilityReserveInfo.bind(this)
        this.onChangeReservationOptions = this.onChangeReservationOptions.bind(this)
        this.onChangeFacilityOptionDetailInfo = this.onChangeFacilityOptionDetailInfo.bind(this)
        this.onChangeTotalCharge = this.onChangeTotalCharge.bind(this)
        this.onChangeFacilityReserveCharge = this.onChangeFacilityReserveCharge.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.registerButton = this.registerButton.bind(this)
        this.changeAcceptedWarnings = this.changeAcceptedWarnings.bind(this)

    }

    async componentDidMount(): Promise<void> {
        const {reservationModel} = this.props
        try {
            await this.props.eventEmitter.showLoading()

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (!currentDateTime || currentDateTime.details === null) {
                return
            }

            // 施設予約取得
            const facilityReserveData: Nullable<NatGetFacilityReserve> = await this.props.asyncCallFunction(
                this.props.facilityReserveRepo.getFacilityReserve.bind(
                    this.props.facilityReserveRepo,
                    this.state.selectedCondominiumCd,
                    this.props.facilityId,
                    this.props.facilityReserveId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (!facilityReserveData || !facilityReserveData.details) {
                return
            }

            // 施設情報取得
            const facilityData: Nullable<FacilityForReservation> = await this.props.asyncCallFunction(
                this.props.reservationsRepositoryForAdmin.getFacilityForReservation.bind(
                    this.props.reservationsRepositoryForAdmin,
                    this.state.selectedCondominiumCd,
                    Number(this.props.facilityId),
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (facilityData === null) {
                return
            }

            // 施設オプション取得
            const facilityOptions: FacilityOption[] = this.extractFacilityOptions(facilityData)

            // 施設オプション詳細情報取得
            const facilityOptionsDetailInfo: NatFacilityOptionDetailInfo[] =
                this.extractFacilityOptionsDetail(facilityReserveData.details.options, facilityData.facilityOptions)

            if (facilityReserveData && facilityReserveData.details) {
                // システム稼働年度頭
                const minDate: string = getYearDateFac()
                // システム日付の翌年の年末
                const maxDate: string = getYearAfterNextDateFac(currentDateTime.details.currentDateTime)

                // 祝日取得
                const holidays: Nullable<string[]> =
                    await this.getHolidays(formatForDateInput(minDate), formatForDateInput(maxDate))

                const startTime = facilityReserveData.details.startTime.split(':')
                const endTime = facilityReserveData.details.endTime.split(':')
                this.setState({
                    facilityData: facilityData,
                    facilityReserveEditInfo: {
                        reserveType: facilityReserveData.details.reserveType,
                        reserveStatus: facilityReserveData.details.reserveStatus,
                        facilityReserveCategory: facilityReserveData.details.facilityReserveCategory,
                        cardKeyFacilityNumber: facilityReserveData.details.cardKeyFacilityNumber,
                        reserveTitle: facilityReserveData.details.reservationTitle,
                        selectedUserList: facilityReserveData.details.selectedUserList,
                        facilityPaymentMethod: facilityReserveData.details.paymentMethod,
                        cashPaymentStatus: facilityReserveData.details.cashPaymentStatus,
                        startMinDate: minDate,
                        startMaxDate: (facilityData.overnightFacilitySetting) ?
                            maxDate : facilityReserveData.details.endDate,
                        startDate: facilityReserveData.details.startDate,
                        startTimeHour: startTime[0],
                        startTimeMinute: startTime[1],
                        endDate: facilityReserveData.details.endDate,
                        endMinDate: facilityReserveData.details.startDate,
                        endMaxDate: maxDate,
                        endTimeHour: endTime[0],
                        endTimeMinute: endTime[1],
                        stayCount: facilityReserveData.details.stayCount,
                    },
                    facilityOptions: facilityOptions,
                    facilityOptionsDetailInfo: facilityOptionsDetailInfo,
                    reservationOptions: this.getReservationOptions(
                        facilityReserveData.details.options, facilityOptions),
                    excudeResidentUserInfo: {
                        excludeCondominiumCd: this.state.selectedCondominiumCd,
                        excludeRidgeCd: facilityReserveData.details.userRidgeCd,
                        excludeRoomNumber: facilityReserveData.details.userRoomNumber,
                    },
                    userRidgeName: facilityReserveData.details.userRidgeName,
                    userRoomNumber: facilityReserveData.details.userRoomNumber,
                    userFamilyName: facilityReserveData.details.userFamilyName,
                    userFirstName: facilityReserveData.details.userFirstName,
                    adminFamilyName: facilityReserveData.details.adminFamilyName,
                    adminFirstName: facilityReserveData.details.adminFirstName,
                    userRoleName: facilityReserveData.details.userRoleName,
                    reserveFamilyName: facilityReserveData.details.reserveFamilyName,
                    reserveFirstName: facilityReserveData.details.reserveFirstName,
                    reserveRoleName: facilityReserveData.details.reserveRoleName,
                    holidays: holidays,
                    currentDateTime: moment(currentDateTime.details.currentDateTime),
                })
                reservationModel
                    .withReservationTitle(facilityReserveData.details.reservationTitle)
                    .withHolidays((facilityData.stayAvailability) ? null : holidays)
                    .withFacilityData(facilityData)
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    componentWillUnmount(): void {
        this.props.reservationModel.reset()
    }

    extractFacilityOptions(facilityData: FacilityForReservation): FacilityOption[] {
        return facilityData.facilityOptions.map(option => {
            const outlineCharge = formatNumberWithCommas(option.charge)
            const outlineUnitTime = (option.chargeUnit !== CHARGE_UNIT.FIXED)
                ? `${option.chargeUnitTime}${option.chargeUnit.label}`
                : option.chargeUnit.label
            return {
                optionId: option.optionId,
                optionName: option.name,
                outline: `${outlineCharge} 円 / ${outlineUnitTime}`,
                minimumQuantity: option.volumeMin,
                maximumQuantity: option.volumeMax,
                quantity: 0,
                unit: option.unitName,
                required: option.appointRequired,
                sortOrder: option.sortOrder,
            }
        }).sort((a, b) => a.sortOrder - b.sortOrder)
    }


    extractFacilityOptionsDetail(facilityyReserveOptions: Options[],
                                 optionSettings: OptionSetting[]): NatFacilityOptionDetailInfo[] {
        return optionSettings.map(optionSetting => {

            const targetFacilityyReserveOptions: Options =
                facilityyReserveOptions.filter((facilityyReserveOption) => facilityyReserveOption.optionId ===
                    optionSetting.optionId)[0]

            const charge = (targetFacilityyReserveOptions) ?
                targetFacilityyReserveOptions.charge : optionSetting.charge

            const cashPaymentStatus = (targetFacilityyReserveOptions) ?
                targetFacilityyReserveOptions.cashPaymentStatus : CASH_PAYMENT_STATUS.YET_PAID.value

            const paymentType = (targetFacilityyReserveOptions) ?
                PAYMENT_TYPE.codeToEnumConstants(targetFacilityyReserveOptions.paymentType)
                : optionSetting.paymentMethod

            return {
                optionId: optionSetting.optionId,
                name: optionSetting.name,
                paymentType: paymentType,
                cashPaymentStatus: cashPaymentStatus,
                chargeUnit: optionSetting.chargeUnit,
                unitName: optionSetting.unitName,
                unitCost: optionSetting.charge,
                chargeUnitTime: optionSetting.chargeUnitTime,
                charge: charge,
            }
        })
    }

    async getHolidays(startDate: string, endDate: string): Promise<Nullable<string[]>> {
        try {
            return await this.props.asyncCallFunction(
                this.props.holidaysRepo.getHolidays.bind(
                    this.props.holidaysRepo,
                    startDate,
                    endDate,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
        } catch (e) {
            throw e
        }
    }

    getReservationOptions(reservationOptions: ReservationOption[],
                          facilityOptions: FacilityOption[]): ReservationOption[] {

        // 施設予約オプションと施設オプションの突き合わせ
        const retReservationOption: ReservationOption[] = []
        reservationOptions.map((reservationOption) => {
            facilityOptions.map((facilityOption) => {
                if (reservationOption.optionId === facilityOption.optionId) {
                    const tmpReservationOption: Nullable<ReservationOption> =
                        this.mergeOption(reservationOption, facilityOption)
                    if (tmpReservationOption) {
                        retReservationOption.push(tmpReservationOption)
                    }
                }
            })
        })

        return retReservationOption.sort((a, b) => a.optionId - b.optionId)
    }

    mergeOption(reservationOption: ReservationOption,
                facilityOption: FacilityOption): Nullable<ReservationOption> {
        if (facilityOption.minimumQuantity <= reservationOption.quantity &&
            reservationOption.quantity <= facilityOption.maximumQuantity) {
            // 予約時の数量が、施設オプションの許容内であれば、そのまま返却
            return reservationOption
        }
        if (facilityOption.required.value === VALID_OR_NOT.VALID.value) {
            // 必須オプションは、初期選択状態にさせる（数量は最小値）
            return {
                optionId: facilityOption.optionId,
                quantity: facilityOption.minimumQuantity,
                sortOrder: facilityOption.sortOrder,
            }
        } else {
            return null
        }
    }

    onChangeFacilityReserveInfo(facilityReserveEditInfo: NatAdminFacilityReserveInfo): void {
        this.setState({facilityReserveEditInfo: facilityReserveEditInfo}, () => {
            this.judgeRegisterButtonDisabled()
        })
    }

    onChangeReservationOptions(reservationOptions: ReservationOption[]): void {
        this.setState({reservationOptions: reservationOptions}, () => {
            this.judgeRegisterButtonDisabled()
        })
    }

    onChangeFacilityOptionDetailInfo(facilityOptionsDetailInfo: NatFacilityOptionDetailInfo[]): void {
        this.setState({facilityOptionsDetailInfo: facilityOptionsDetailInfo},
            () => {
                this.judgeRegisterButtonDisabled()
            })
    }

    onChangeTotalCharge(totalCharge: Nullable<number>): void {
        this.setState({totalCharge: totalCharge}, () => {
            this.judgeRegisterButtonDisabled()
        })
    }

    onChangeFacilityReserveCharge(facilityReserveCharge: FacilityReserveCharge[]): void {
        this.setState({facilityReserveCharge: facilityReserveCharge}, () => {
            this.judgeRegisterButtonDisabled()
        })
    }

    changeAcceptedWarnings(acceptAll: boolean, acceptedWarning: AcceptedWarning[]): void {
        this.setState({
            cheked: acceptAll,
            acceptedWarning: acceptedWarning,
        }, () => {
            this.judgeRegisterButtonDisabled()
        })
    }

    // 登録ボタンの表示・非表示制御
    judgeRegisterButtonDisabled(): void {
        const {
            facilityData, facilityReserveEditInfo, facilityOptions,
            reservationOptions, information, cheked,
        } = this.state
        let disable: boolean = false

        if (facilityData === null || facilityReserveEditInfo === null) {
            return
        }

        if (facilityData.stayAvailability !== null && facilityData.stayAvailability) {
            // 宿泊
            disable = facilityReserveEditInfo.startDate === '' ||
                facilityReserveEditInfo.stayCount === ''
        } else {
            // 時間貸し
            disable = facilityReserveEditInfo.startDate === '' ||
                facilityReserveEditInfo.startTimeHour === '' ||
                facilityReserveEditInfo.startTimeMinute === '' ||
                facilityReserveEditInfo.endDate === '' ||
                facilityReserveEditInfo.endTimeHour === '' ||
                facilityReserveEditInfo.endTimeMinute === ''
        }

        if (disable) {
            this.setState({registerButtonDisabled: disable})
            return
        }

        disable = facilityReserveEditInfo.facilityPaymentMethod === '' ||
            (facilityReserveEditInfo.facilityPaymentMethod === PAYMENT_TYPE.CASH.value &&
                facilityReserveEditInfo.cashPaymentStatus === '')

        if (disable) {
            this.setState({registerButtonDisabled: disable})
            return
        }

        if (facilityOptions !== null) {
            facilityOptions.map((facilityOption) => {
                if (facilityOption.required === VALID_OR_NOT.VALID) {
                    if (reservationOptions === null) {
                        disable = true
                    } else {
                        const targetOption: ReservationOption | undefined =
                            reservationOptions.find(reservationOption =>
                                reservationOption.optionId === facilityOption.optionId)
                        if (!targetOption) {
                            disable = true
                        }
                    }
                }
            })
        }

        if (facilityReserveEditInfo.facilityReserveCategory !== FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value &&
            this.state.totalCharge === null) {
            disable = true
        }

        if (information.length > 0) {
            if (cheked) {
                disable = false
            } else {
                disable = true
            }
        }

        this.setState({registerButtonDisabled: disable})
    }


    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        const {facilityReserveId, facilityId, navigate, eventEmitter} = this.props
        const {
            facilityData, facilityReserveEditInfo, reservationOptions,
            totalCharge, facilityReserveCharge, acceptedWarning, version,
        } = this.state

        eventEmitter.closeDialog()
        this.setState({information: []})

        if (facilityData !== null &&
            facilityReserveEditInfo !== null &&
            reservationOptions !== null) {
            await this.props.eventEmitter.showLoading()
            try {
                const sharedUseRoomNumber: SharedUseRoomNumber[] =
                    facilityReserveEditInfo.selectedUserList.map((selectedUser) => {
                        return {
                            userRidgeCd: selectedUser.ridgeCd,
                            userRoomNumber: selectedUser.roomNumber,
                        }
                    })

                const facilityReserveOption: FacilityReserveOption[] =
                    reservationOptions.map((reservationOption) => {
                        return {
                            optionId: reservationOption.optionId,
                            volume: reservationOption.quantity,
                        }
                    })

                const reqFacilityReserveCharge: FacilityReserveCharge[] = []
                facilityReserveCharge.map((reserveCharge) => {
                    const tempFacilityReserveCharge: FacilityReserveCharge = {
                        optionId: reserveCharge.optionId,
                        optionName: reserveCharge.optionName,
                        unitCharge: reserveCharge.unitCharge,
                        paymentMethod: reserveCharge.paymentMethod,
                        charge: reserveCharge.charge,
                    }

                    if (reserveCharge.paymentMethod === PAYMENT_TYPE.CASH.value) {
                        tempFacilityReserveCharge.cashPaymentStatus = reserveCharge.cashPaymentStatus
                    }

                    reqFacilityReserveCharge.push(tempFacilityReserveCharge)
                })

                let response: Nullable<NatPutFacilityReserveOvernight |
                    NatPutFacilityReserveDuration> = null

                if (facilityData.stayAvailability) {
                    // 宿泊
                    const request: NatPutFacilityReserveOvernightRequest = {
                        reserveTitle: facilityReserveEditInfo.reserveTitle,
                        reserveStartDate: facilityReserveEditInfo.startDate,
                        stayCount: facilityReserveEditInfo.stayCount,
                        sharedUseRoomNumber: sharedUseRoomNumber,
                        facilityReserveOption: facilityReserveOption,
                        totalCharge: totalCharge,
                        facilityReserveCharge: reqFacilityReserveCharge,
                        version: version,
                    }

                    if (acceptedWarning.length > 0) {
                        request.permissionWarning = acceptedWarning
                    } else {
                        request.permissionWarning = []
                    }

                    response =
                        await this.props.asyncCallFunction(
                            this.props.facilityReserveRepo.putUpdateFacilityReserveOvernight.bind(
                                this.props.facilityReserveRepo, facilityReserveId, request),
                            async (httpErrorOrNetworkError) => {
                                await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                            },
                            {defaultErrorTitle: Messages.EOPCA0002.toString('施設予約')},
                        )
                } else {
                    // 時間貸
                    const request: NatPutFacilityReserveDurationRequest = {
                        reserveTitle: facilityReserveEditInfo.reserveTitle,
                        reserveStartDatetime: '',
                        reserveEndDatetime: '',
                        sharedUseRoomNumber: sharedUseRoomNumber,
                        facilityReserveOption: facilityReserveOption,
                        totalCharge: totalCharge,
                        facilityReserveCharge: reqFacilityReserveCharge,
                        version: version,
                    }

                    if (facilityReserveEditInfo.startDate &&
                        facilityReserveEditInfo.startTimeHour &&
                        facilityReserveEditInfo.startTimeMinute) {
                        request.reserveStartDatetime = `${facilityReserveEditInfo.startDate} ${('0' + getHourLabel(
                            facilityReserveEditInfo.startTimeHour)).slice(-2)}:${('0' + getMinutsLabel(
                            facilityReserveEditInfo.startTimeMinute)).slice(-2)}`
                    }

                    if (facilityReserveEditInfo.endDate &&
                        facilityReserveEditInfo.endTimeHour &&
                        facilityReserveEditInfo.endTimeMinute) {
                        request.reserveEndDatetime = `${facilityReserveEditInfo.endDate} ${('0' + getHourLabel(
                            facilityReserveEditInfo.endTimeHour)).slice(-2)}:${('0' + getMinutsLabel(
                            facilityReserveEditInfo.endTimeMinute)).slice(-2)}`
                    }

                    if (acceptedWarning.length > 0) {
                        request.permissionWarning = acceptedWarning
                    } else {
                        request.permissionWarning = []
                    }

                    response =
                        await this.props.asyncCallFunction(
                            this.props.facilityReserveRepo.putUpdateFacilityReserveDuration.bind(
                                this.props.facilityReserveRepo, facilityReserveId, request),
                            async (httpErrorOrNetworkError) => {
                                await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                            },
                            {defaultErrorTitle: Messages.EOPCA0002.toString('施設予約')},
                        )
                }
                if (response && response.requestError === null) {
                    if (response.informations !== null) {
                        this.setState({information: response.informations})
                        this.judgeRegisterButtonDisabled()
                    } else {
                        navigate(
                            `/admin/facilityReserve/${facilityId}/${facilityReserveId}`,
                            {
                                state: {
                                    initialMessage: {
                                        title: null,
                                        messageLevel: MESSAGE_TYPE.INFORMATION,
                                        detail: (facilityReserveEditInfo.reserveTitle !== '') ?
                                            Messages.IOPCC0004.toString(
                                                '予約情報', facilityReserveEditInfo.reserveTitle) :
                                            Messages.IOPCC0004.toString(
                                                '予約情報', facilityData.facilityName),
                                    },
                                },
                            },
                        )
                    }
                }
            } finally {
                eventEmitter.closeLoading()
            }
        }

    }

    async registerButton(): Promise<void> {
        const {eventEmitter} = this.props

        await eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('予約情報'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    renderPageFooterArea(): ReactNode {
        const {facilityId, facilityReserveId, navigate} = this.props
        const {registerButtonDisabled} = this.state

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={registerButtonDisabled}
                        onClick={this.registerButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => navigate(
                            `/admin/facilityReserve/${facilityId}/${facilityReserveId}`,
                        )}
                    >
                        施設予約詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        const {
            isLoadCompleted, facilityData, facilityOptions,
            facilityOptionsDetailInfo, reservationOptions, facilityReserveEditInfo,
            userRidgeName, userRoomNumber, userFamilyName,
            userFirstName, adminFamilyName, adminFirstName,
            userRoleName, reserveFamilyName, reserveFirstName, reserveRoleName, holidays,
        } = this.state

        if (!isLoadCompleted) {
            return null
        }

        if (facilityData !== null &&
            facilityOptions !== null &&
            facilityOptionsDetailInfo !== null &&
            reservationOptions !== null &&
            facilityReserveEditInfo !== null) {
            return (
                <>
                    <PageMainArea>
                        <form>
                            <NatAdminFacilityReserveInfoComponent
                                facilityData={facilityData}
                                facilityReserveEditInfo={facilityReserveEditInfo}
                                holidays={holidays}
                                reservationOptions={reservationOptions}
                                RoomToResidentRepo={this.props.RoomToResidentRepo}
                                RidgeRepo={this.props.RidgeRepo}
                                reservationModel={this.props.reservationModel}
                                excudeResidentUserInfo={this.state.excudeResidentUserInfo}
                                currentDateTime={this.state.currentDateTime}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                                onChangeFacilityReserveInfo={this.onChangeFacilityReserveInfo}
                            />
                            <NatAdminFacilityReserveOptionComponent
                                reservationModel={this.props.reservationModel}
                                facilityOptions={facilityOptions}
                                facilityOptionsDetailInfo={facilityOptionsDetailInfo}
                                reservationOptions={reservationOptions}
                                facilityReserveCategory={facilityReserveEditInfo.facilityReserveCategory}
                                eventEmitter={this.props.eventEmitter}
                                onChangeReservationOptions={this.onChangeReservationOptions}
                                onChangeFacilityOptionDetailInfo={this.onChangeFacilityOptionDetailInfo}
                            />
                            <NatAdminFacilityReserveChargeViewComponent
                                reservationModel={this.props.reservationModel}
                                facilityName={facilityData.facilityName}
                                facilityReserveCategory={facilityReserveEditInfo.facilityReserveCategory}
                                facilityReserveEditInfo={facilityReserveEditInfo}
                                facilityOptions={facilityOptions}
                                facilityOptionsDetailInfo={facilityOptionsDetailInfo}
                                reservationOptions={reservationOptions}
                                stayAvailability={facilityData.stayAvailability}
                                onChangeTotalCharge={this.onChangeTotalCharge}
                                onChangeFacilityReserveCharge={this.onChangeFacilityReserveCharge}
                            />
                            <NatAdminFacilityReserveUserInfoViewComponent
                                facilityReserveCategory={facilityReserveEditInfo.facilityReserveCategory}
                                userRidgeName={userRidgeName}
                                userRoomNumber={userRoomNumber}
                                userFamilyName={userFamilyName}
                                userFirstName={userFirstName}
                                adminFamilyName={adminFamilyName}
                                adminFirstName={adminFirstName}
                                userRoleName={userRoleName}
                                stayAvailability={facilityData.stayAvailability}
                            />
                            <NatAdminFacilityReserveReserveUserInfoViewComponent
                                reserveFamilyName={reserveFamilyName}
                                reserveFirstName={reserveFirstName}
                                reserveRoleName={reserveRoleName}
                                stayAvailability={facilityData.stayAvailability}
                            />
                        </form>
                    </PageMainArea>
                    <Box height={16}/>
                    <NatAdminCommonAcceptedWarningComponent
                        title={'ご確認ください'}
                        description={'内容をご確認いただき、問題なければチェックしたうえで再度登録ボタンを押してください。'}
                        warnings={getAcceptedWarningList(this.state.information)}
                        changeAcceptedWarnings={this.changeAcceptedWarnings}
                        doOpenAnimation={true}/>
                    <PageFooterArea>
                        {this.renderPageFooterArea()}
                    </PageFooterArea>
                </>
            )
        }
        return null
    }
}

export default createAdminPage(NatAdminFacilityReserveEditPage)
